// © 2024–2026 Jos Jozef Sytze van der Werf — Alle rechten voorbehouden.
/**
 * FuneralCostsPage - standalone pagina voor uitvaartverzekering & kosten
 * Rendert NewStep12FuneralCosts buiten de wizard.
 * Route: /wishes/funeral-costs
 */
import { useState, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { ROUTES }  from '@/lib/constants/routes'
import { useReturnNav } from '@/lib/returnNav'
import { PrimaryActionButton } from '@/components/ui/PrimaryActionButton'
import { SecondaryActionButton } from '@/components/ui/SecondaryActionButton'
import { CheckCircle2 } from 'lucide-react'
import { SaveStatusBadge } from '@/components/ui/SaveStatusBadge'
import { NewStep12FuneralCosts } from '@/modules/wizard/steps/NewStep12FuneralCosts'
import type { SaveStatus } from '@/hooks/useAutosave'

export function FuneralCostsPage() {
  const [saveStatus, setSaveStatus] = useState<SaveStatus>('idle')
  const saveRef  = useRef<(() => Promise<void>) | null>(null)
  const navigate = useNavigate()
  const { fromSource, target, label } = useReturnNav()
  return (
    <div>
      <div className="flex items-center justify-between mb-5">
        <button onClick={async () => { await saveRef.current?.(); navigate(ROUTES.DASHBOARD) }}
          className="flex items-center gap-1.5 text-sm text-ink-4 hover:text-ink-3 transition-colors mb-5 group">
          <svg className="h-4 w-4 group-hover:-translate-x-0.5 transition-transform" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" /></svg>
          Terug naar dashboard
        </button>
        <SaveStatusBadge status={saveStatus} />
      </div>
      <NewStep12FuneralCosts onSaveStatus={setSaveStatus} saveRef={saveRef} />
      <div className="flex flex-col gap-2 mt-2">
        <PrimaryActionButton onClick={async () => { await saveRef.current?.(); navigate(fromSource ? target : ROUTES.WISHES_FUNERAL) }} icon={<CheckCircle2 className="h-5 w-5" />}>
          {fromSource ? label : 'Klaar - terug naar Uitvaartwensen'}
        </PrimaryActionButton>
        <SecondaryActionButton onClick={async () => { await saveRef.current?.(); navigate(-1) }}>Terug naar vorige scherm</SecondaryActionButton>
      </div>
    </div>
  )
}
